var _defs, _g, _path, _rect, _path2, _circle, _g2, _g3, _path3, _path4, _rect2, _path5, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptimization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2378.69 2232.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 867.35,
    y1: 938.35,
    x2: 843.9,
    y2: 938.35,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 504.96,
    y1: 671.23,
    x2: 507.53,
    y2: 685.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1949.09,
    y1: 604.14,
    x2: 2071.67,
    y2: 604.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2075.66,
    y1: 652.9,
    x2: 1981.54,
    y2: 652.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d5d5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2075.66,
    y1: 620.72,
    x2: 1981.54,
    y2: 620.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2073.7,
    y1: 645.17,
    x2: 1982.41,
    y2: 645.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2069.94,
    y1: 669.63,
    x2: 1984.07,
    y2: 669.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2178.9,
    y1: 441.79,
    x2: 1929.25,
    y2: 441.79,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2632.06,
    y1: 1996.02,
    x2: 1290.28,
    y2: 2086.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ca3d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 742.01,
    y1: 1886.12,
    x2: 2435.39,
    y2: 1886.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddcdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2632.06,
    y1: 1990.98,
    x2: 1290.28,
    y2: 2081.14,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 742.01,
    y1: 2052.28,
    x2: 2435.39,
    y2: 2052.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1740.62,
    y1: 1987.6,
    x2: 986.42,
    y2: 1906,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1705.24,
    y1: 1975.9,
    x2: 2253.52,
    y2: 1953.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f25227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2120.08,
    y1: 1831.93,
    x2: 1593.43,
    y2: 1867.31,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2121.74,
    y1: 1856.64,
    x2: 1686.63,
    y2: 1885.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1059.84,
    y1: 1725.04,
    x2: 2049.14,
    y2: 1725.04,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1740.62,
    y1: 1982.5,
    x2: 986.42,
    y2: 1900.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddcdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1278.07,
    y1: 1446.65,
    x2: 1738.49,
    y2: 1446.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaa5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddcdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1188.24,
    y1: 1759.89,
    x2: 2049.14,
    y2: 1759.89,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 904.74,
    y1: 1087.61,
    x2: 904.74,
    y2: 1285.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c6fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313f68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 883.14,
    y1: 753.12,
    x2: 883.14,
    y2: 1361.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1169.75,
    y1: 908.44,
    x2: 1169.75,
    y2: 1270.85,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1148.15,
    y1: 753.12,
    x2: 1148.15,
    y2: 1361.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1434.77,
    y1: 642.15,
    x2: 1434.77,
    y2: 1249.12,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1413.17,
    y1: 753.12,
    x2: 1413.17,
    y2: 1361.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1699.79,
    y1: 747.37,
    x2: 1699.79,
    y2: 1257.71,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1678.18,
    y1: 753.12,
    x2: 1678.18,
    y2: 1361.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1453.52,
    y1: 1455.06,
    x2: 2260.76,
    y2: 759.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f45f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f25227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 2062.85,
    y1: 630.26,
    x2: 1078.29,
    y2: 2108.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f56a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1766.18,
    y1: 835.55,
    x2: 982.42,
    y2: 2012.27,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 2051.47,
    y1: 414.11,
    x2: 1871.14,
    y2: 684.84,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 531.74,
    y1: 151.22,
    x2: 1389.11,
    y2: 151.22,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1045.29,
    y1: -13.63,
    x2: 783.03,
    y2: 380.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 531.74,
    y1: 269.37,
    x2: 1389.11,
    y2: 269.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 986.65,
    y1: 122.3,
    x2: 752.67,
    y2: 473.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 531.74,
    y1: 387.51,
    x2: 1389.11,
    y2: 387.51,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 902.88,
    y1: 265.84,
    x2: 709.31,
    y2: 556.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1255.55,
    y1: 151.22,
    x2: 1317.85,
    y2: 151.22,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1165.76,
    y1: 269.37,
    x2: 1228.06,
    y2: 269.37,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1040.19,
    y1: 387.51,
    x2: 1102.5,
    y2: 387.51,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 3427.67,
    y1: 2619.34,
    x2: 3427.67,
    y2: 2201.59,
    gradientTransform: "rotate(24.44 4786.798 -432.786)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 3427.67,
    y1: 2120.67,
    x2: 3427.67,
    y2: 2520.77,
    gradientTransform: "rotate(24.44 4786.798 -432.786)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 2405.96,
    y1: 1142.42,
    x2: 2550.55,
    y2: 1142.42,
    gradientTransform: "rotate(50.22 2304.476 1251.327)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 974.68,
    y1: 999.2,
    x2: 1010,
    y2: 1124.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dfdede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d5d5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1263.24,
    y1: 994.27,
    x2: 799.72,
    y2: 994.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1080.73,
    y1: 1174.13,
    x2: 574.97,
    y2: 1174.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1080.51,
    y1: 1151.39,
    x2: 579.75,
    y2: 1151.39,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 996.14,
    y1: 1144.38,
    x2: 655.68,
    y2: 1144.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 875.97,
    y1: 920.77,
    x2: 852.52,
    y2: 920.77,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 894.2,
    y1: 933.79,
    x2: 870.75,
    y2: 933.79,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 912.43,
    y1: 946.81,
    x2: 888.98,
    y2: 946.81,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 930.66,
    y1: 959.83,
    x2: 907.21,
    y2: 959.83,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 948.89,
    y1: 972.86,
    x2: 925.44,
    y2: 972.86,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 967.12,
    y1: 985.88,
    x2: 943.67,
    y2: 985.88,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 985.35,
    y1: 998.9,
    x2: 961.9,
    y2: 998.9,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1003.58,
    y1: 1011.92,
    x2: 980.13,
    y2: 1011.92,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1021.81,
    y1: 1024.94,
    x2: 998.36,
    y2: 1024.94,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1040.04,
    y1: 1037.96,
    x2: 1016.59,
    y2: 1037.96,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1058.27,
    y1: 1050.98,
    x2: 1034.82,
    y2: 1050.98,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 849.12,
    y1: 925.33,
    x2: 825.67,
    y2: 925.33,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2061.11,
    y1: 685.41,
    x2: 1987.97,
    y2: 685.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d7ece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17538c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 885.58,
    y1: 951.38,
    x2: 862.13,
    y2: 951.38,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 903.81,
    y1: 964.4,
    x2: 880.36,
    y2: 964.4,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 922.04,
    y1: 977.42,
    x2: 898.59,
    y2: 977.42,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 940.27,
    y1: 990.44,
    x2: 916.82,
    y2: 990.44,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 958.5,
    y1: 1003.46,
    x2: 935.05,
    y2: 1003.46,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 976.73,
    y1: 1016.48,
    x2: 953.28,
    y2: 1016.48,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 994.96,
    y1: 1029.5,
    x2: 971.51,
    y2: 1029.5,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1013.19,
    y1: 1042.53,
    x2: 989.74,
    y2: 1042.53,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1031.42,
    y1: 1055.55,
    x2: 1007.97,
    y2: 1055.55,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 822.28,
    y1: 929.9,
    x2: 798.83,
    y2: 929.9,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 840.51,
    y1: 942.92,
    x2: 817.06,
    y2: 942.92,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 858.73,
    y1: 955.94,
    x2: 835.29,
    y2: 955.94,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 876.96,
    y1: 968.96,
    x2: 853.52,
    y2: 968.96,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 895.19,
    y1: 981.98,
    x2: 871.75,
    y2: 981.98,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 913.42,
    y1: 995,
    x2: 889.98,
    y2: 995,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 931.65,
    y1: 1008.02,
    x2: 908.21,
    y2: 1008.02,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 949.88,
    y1: 1021.05,
    x2: 926.44,
    y2: 1021.05,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 968.11,
    y1: 1034.07,
    x2: 944.67,
    y2: 1034.07,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 986.34,
    y1: 1047.09,
    x2: 962.9,
    y2: 1047.09,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1004.57,
    y1: 1060.11,
    x2: 981.13,
    y2: 1060.11,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 795.43,
    y1: 934.46,
    x2: 771.98,
    y2: 934.46,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 813.66,
    y1: 947.48,
    x2: 790.21,
    y2: 947.48,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 831.89,
    y1: 960.5,
    x2: 808.44,
    y2: 960.5,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 850.12,
    y1: 973.52,
    x2: 826.67,
    y2: 973.52,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 868.35,
    y1: 986.54,
    x2: 844.9,
    y2: 986.54,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 886.58,
    y1: 999.57,
    x2: 863.13,
    y2: 999.57,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 904.81,
    y1: 1012.59,
    x2: 881.36,
    y2: 1012.59,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 923.04,
    y1: 1025.61,
    x2: 899.59,
    y2: 1025.61,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 941.27,
    y1: 1038.63,
    x2: 917.82,
    y2: 1038.63,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 959.5,
    y1: 1051.65,
    x2: 936.05,
    y2: 1051.65,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 977.73,
    y1: 1064.67,
    x2: 954.28,
    y2: 1064.67,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 1078.04,
    y1: 1064.67,
    x2: 1054.59,
    y2: 1064.67,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1051.19,
    y1: 1069.24,
    x2: 1027.74,
    y2: 1069.24,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1024.34,
    y1: 1073.8,
    x2: 1000.89,
    y2: 1073.8,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 997.5,
    y1: 1078.36,
    x2: 974.05,
    y2: 1078.36,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1097.8,
    y1: 1078.36,
    x2: 1074.36,
    y2: 1078.36,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1070.96,
    y1: 1082.92,
    x2: 1047.51,
    y2: 1082.92,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1044.11,
    y1: 1087.49,
    x2: 1020.66,
    y2: 1087.49,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1017.26,
    y1: 1092.05,
    x2: 993.82,
    y2: 1092.05,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1117.57,
    y1: 1092.05,
    x2: 1094.12,
    y2: 1092.05,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1090.73,
    y1: 1096.61,
    x2: 1067.28,
    y2: 1096.61,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1063.88,
    y1: 1101.17,
    x2: 1040.43,
    y2: 1101.17,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1037.03,
    y1: 1105.74,
    x2: 1013.58,
    y2: 1105.74,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 1137.34,
    y1: 1105.74,
    x2: 1113.89,
    y2: 1105.74,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1110.49,
    y1: 1110.3,
    x2: 1087.05,
    y2: 1110.3,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1083.65,
    y1: 1114.86,
    x2: 1060.2,
    y2: 1114.86,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1056.8,
    y1: 1119.42,
    x2: 1033.35,
    y2: 1119.42,
    gradientTransform: "matrix(1 0 .07 .95 -253.31 173.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -449.02,
    y1: 1547.24,
    x2: -449.02,
    y2: 1514.25,
    gradientTransform: "translate(1444.23 -565.07)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -407.05,
    y1: 1545.85,
    x2: -407.05,
    y2: 1495.31,
    gradientTransform: "translate(1443.8 -540.4)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -365.08,
    y1: 1543.14,
    x2: -365.08,
    y2: 1458.5,
    gradientTransform: "rotate(90 616.55 1961.46)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -323.11,
    y1: 1544.21,
    x2: -323.11,
    y2: 1473.04,
    gradientTransform: "translate(1437.76 -492.61)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 878.51,
    y1: 1030.64,
    x2: 838.41,
    y2: 914.52,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 822.2,
    y1: 1049.63,
    x2: 782.57,
    y2: 934.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 859.68,
    y1: 1036.68,
    x2: 820.05,
    y2: 921.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 803.51,
    y1: 1056.08,
    x2: 763.88,
    y2: 941.35,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 844.4,
    y1: 974.15,
    x2: 857.15,
    y2: 954.45,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 769.26,
    y1: 991.05,
    x2: 800.75,
    y2: 942.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 833.52,
    y1: 1055.24,
    x2: 865,
    y2: 1006.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 769.32,
    y1: 998.7,
    x2: 802.04,
    y2: 1049.18,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.16}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#36363d}.cls-2{opacity:0}.cls-3{opacity:.04}.cls-4{opacity:.07}.cls-5{opacity:.11}.cls-6{opacity:.15}.cls-7{opacity:.19}.cls-8{opacity:.22}.cls-9{opacity:.26}.cls-10{opacity:.3}.cls-11{opacity:.33}.cls-12{opacity:.37}.cls-13{opacity:.41}.cls-14{opacity:.44}.cls-15{opacity:.48}.cls-16{opacity:.52}.cls-17{opacity:.56}.cls-18{opacity:.59}.cls-19{opacity:.63}.cls-20{opacity:.67}.cls-21{opacity:.7}.cls-22{opacity:.74}.cls-23{opacity:.78}.cls-24{opacity:.81}.cls-25{opacity:.85}.cls-26{opacity:.89}.cls-27{opacity:.93}.cls-28{opacity:.96}.cls-73{fill:#cecece}.cls-75{fill:#fff}.cls-145{fill:#d6d5d5}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1278.05,
    cy: 1843.64,
    rx: 784.22,
    ry: 382.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1278.05,
    cy: 1843.64,
    rx: 771.38,
    ry: 376.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1278.05,
    cy: 1843.64,
    rx: 758.55,
    ry: 369.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1278.05,
    cy: 1843.64,
    rx: 745.71,
    ry: 363.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1278.05,
    cy: 1843.64,
    rx: 732.87,
    ry: 357.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1278.05,
    cy: 1843.64,
    rx: 720.04,
    ry: 351.01
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1278.05,
    cy: 1843.64,
    rx: 707.2,
    ry: 344.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1278.05,
    cy: 1843.64,
    rx: 694.36,
    ry: 338.49
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1278.05,
    cy: 1843.64,
    rx: 681.53,
    ry: 332.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1278.05,
    cy: 1843.64,
    rx: 668.69,
    ry: 325.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1278.05,
    cy: 1843.64,
    rx: 655.85,
    ry: 319.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1278.05,
    cy: 1843.64,
    rx: 643.02,
    ry: 313.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1278.05,
    cy: 1843.64,
    rx: 630.18,
    ry: 307.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1278.05,
    cy: 1843.64,
    rx: 617.34,
    ry: 300.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1278.05,
    cy: 1843.64,
    rx: 604.51,
    ry: 294.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1278.05,
    cy: 1843.64,
    rx: 591.67,
    ry: 288.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1278.05,
    cy: 1843.64,
    rx: 578.83,
    ry: 282.17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 1278.05,
    cy: 1843.64,
    rx: 566,
    ry: 275.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 1278.05,
    cy: 1843.64,
    rx: 553.16,
    ry: 269.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 1278.05,
    cy: 1843.64,
    rx: 540.32,
    ry: 263.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 1278.05,
    cy: 1843.64,
    rx: 527.48,
    ry: 257.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1278.05,
    cy: 1843.64,
    rx: 514.65,
    ry: 250.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1278.05,
    cy: 1843.64,
    rx: 501.81,
    ry: 244.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 1278.05,
    cy: 1843.64,
    rx: 488.97,
    ry: 238.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 1278.05,
    cy: 1843.64,
    rx: 476.14,
    ry: 232.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 1278.05,
    cy: 1843.64,
    rx: 463.3,
    ry: 225.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1278.05,
    cy: 1843.64,
    rx: 450.46,
    ry: 219.59
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m2058 647.51-4.86 61.49c0 7.92-19.14 14.32-42.76 14.32s-42.76-6.4-42.76-14.32l-4.87-61.47c0 8.82 21.32 16 47.63 16s47.62-7.2 47.62-16.02Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2071.67 604.14c0 11.34-27.44 20.53-61.29 20.53s-61.29-9.19-61.29-20.53 27.44-20.53 61.29-20.53 61.29 9.23 61.29 20.53Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2071.67 604.14-6.27 79.09c0 10.19-24.63 18.43-55 18.43s-55-8.24-55-18.43l-6.27-79.09c0 11.34 27.44 20.53 61.29 20.53s61.25-9.19 61.25-20.53Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010.38 637.3c29.09 0 53.39-6.79 59.66-15.9l1.63-17.26c0 11.34-27.44 20.53-61.29 20.53s-61.29-9.19-61.29-20.53l1.63 17.26c6.28 9.11 30.57 15.9 59.66 15.9Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010.38 661.75c28.22 0 51.78-6.78 57.87-15.89l1.57-17.27c0 11.35-26.6 20.53-59.44 20.53s-59.44-9.18-59.44-20.53l1.57 17.27c6.09 9.14 29.65 15.89 57.87 15.89Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010.38 686.21c26.55 0 48.71-6.79 54.44-15.9l1.48-17.26c0 11.34-25 20.53-55.92 20.53s-55.92-9.19-55.92-20.53l1.48 17.26c5.73 9.11 27.9 15.9 54.44 15.9Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2167.62 393.64c0-77.21-75.79-139.25-167.1-134.48-78.16 4.09-141.89 58.44-147 125.39a118.23 118.23 0 0 0 15.5 68.07l59.26 133.16c13 29.2 45.68 38.9 82.15 38.9 0 0 64.91 2 82.15-38.9l59.26-133.16a118.63 118.63 0 0 0 15.78-58.98Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2435.39 1891.13v65.27c0 186-379 336.78-846.66 336.78S742 2142.42 742 1956.4v-65.27c0 186 379.1 336.78 846.72 336.78s846.67-150.77 846.67-336.78Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2435.39 1886.09c0 186-379 336.78-846.66 336.78S742 2072.11 742 1886.09s379.1-336.73 846.72-336.73 846.67 150.77 846.67 336.73Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2435.39 1886.09v65.27c0 186-379 336.79-846.66 336.79S742 2137.38 742 1951.36v-65.27c0 186 379.1 336.78 846.72 336.78s846.67-150.76 846.67-336.78Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.73 2214.08c-463.92 0-840.65-148.4-846.58-332.39 0 1.47-.14 2.93-.14 4.4 0 186 379.1 336.78 846.72 336.78s846.66-150.76 846.66-336.78c0-1.47-.09-2.93-.14-4.4-5.92 183.99-382.6 332.39-846.52 332.39Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2117.56 1804.12v134.47c0 101.07-179 185.43-417.79 205.73V2014.5l-2.37-4.44c239.94-19.92 420.16-104.54 420.16-205.94Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "#d34418"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.4 1936.08c-35.1 2.92-71.42 4.44-108.68 4.44-292.11 0-528.88-94.17-528.88-210.38v206.75c0 116.21 236.77 210.38 528.88 210.38 38.1 0 75.23-1.61 111-4.65v-202.1Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2117.56 1797.32v134.48c0 101.06-179 185.42-417.79 205.72V2007.7l-2.37-4.44c239.94-19.92 420.16-104.53 420.16-205.94Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2117.56 1797.32c0 101.41-180.22 186-420.16 205.94l-108.68-205.94 460.42-103.56c43.56 30.58 68.42 65.93 68.42 103.56Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2097.73 1740.16c10.22 16.33 15.71 33.4 15.71 51 0 101.28-179.82 185.82-419.34 205.86l3.3 6.26c239.94-19.92 420.16-104.53 420.16-205.94 0-19.83-6.95-39-19.83-57.18Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1588.72 1725 108.68 206c-35.1 2.92-71.42 4.44-108.68 4.44-292.11 0-528.88-94.17-528.88-210.38s236.77-210.33 528.88-210.33c197.44 0 369.59 43 460.42 106.77Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.4 1931c-35.1 2.92-71.42 4.44-108.68 4.44-292.11 0-528.88-94.17-528.88-210.38v206.74c0 116.2 236.77 210.37 528.88 210.37 38.1 0 75.23-1.61 111-4.65v-202.1Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-18)"
    },
    d: "M1738.49 1362.56v72.3l-426.32 95.89-34.1-64.63 460.42-103.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2049.14 1621.46c-19-13.34-41.61-25.76-67.22-37.08 22.14 10.28 41.84 21.41 58.72 33.26l-460.42 103.56 108.68 205.94c-35.1 2.92-71.42 4.44-108.68 4.44-155.45 0-295.22-26.67-392-69.14 97 44.68 240.42 73 400.48 73 37.26 0 73.58-1.52 108.68-4.44l-108.66-206Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.73 1072.44h163a3 3 0 0 1 3 3v224.65a3 3 0 0 1-3 3h-163v-230.65Z",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800.13,
    y: 1072.44,
    width: 166.02,
    height: 230.6,
    rx: 2.46,
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.74 880.66h163a3 3 0 0 1 3 3v416.44a3 3 0 0 1-3 3h-163V880.66Z",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.14,
    y: 880.66,
    width: 166.02,
    height: 422.39,
    rx: 2.46,
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.76 595.62h163a3 3 0 0 1 3 3v701.48a3 3 0 0 1-3 3h-163V595.62Z",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1330.16,
    y: 595.62,
    width: 166.02,
    height: 707.43,
    rx: 2.46,
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.78 708.25h163a3 3 0 0 1 3 3v588.85a3 3 0 0 1-3 3h-163V708.25Z",
    style: {
      fill: "url(#linear-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1595.17,
    y: 708.25,
    width: 166.02,
    height: 594.8,
    rx: 2.46,
    style: {
      fill: "url(#linear-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m702 1675.66 713.49-588.35a80.78 80.78 0 0 1 100.07-2.16L1757.87 1268a56.49 56.49 0 0 0 74.91-6.11l303.79-318.68a37.49 37.49 0 0 0-.87-52.62l-59-47.73-12.8-22.75 418.36-116.41 12.79 22.74-138.51 377.39-59.43-47a37.49 37.49 0 0 0-49.83 2.94l-416.13 417.7a56.49 56.49 0 0 1-74.24 5.07l-266.15-202.74a80.78 80.78 0 0 0-90.56-5l-684.38 432.95c-8.53 5.13-21.51-25.75-13.82-32.09Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m714.79 1698.41 713.49-588.36a80.79 80.79 0 0 1 100.07-2.15l242.32 182.87a56.49 56.49 0 0 0 74.91-6.11L2149.37 966a37.5 37.5 0 0 0-.87-52.63l-71.78-70.47 418.35-116.42-125.72 400.12-59.42-47a37.48 37.48 0 0 0-49.83 2.94L1844 1500.19a56.48 56.48 0 0 1-74.23 5.07l-266.17-202.72a80.82 80.82 0 0 0-90.57-5l-688.98 413.97c-8.54 5.13-16.95-6.77-9.26-13.1Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m714.79 1708 713.49-588.35a80.8 80.8 0 0 1 100.07-2.16l242.32 182.88a56.48 56.48 0 0 0 74.91-6.12l303.79-318.65a37.44 37.44 0 0 0 10-30.74 37.35 37.35 0 0 1-10 21.12l-303.79 318.68a56.49 56.49 0 0 1-74.91 6.11l-242.32-182.87a80.79 80.79 0 0 0-100.07 2.15l-713.49 588.36a7.77 7.77 0 0 0-1.34 11 8.63 8.63 0 0 1 1.34-1.41Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-31)"
    },
    d: "m2181.1 478.11 3.32-10.55-418.36 116.42 7.64 7.5 407.4-113.37z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.74,
    y: 128.25,
    width: 857.37,
    height: 45.95,
    rx: 6.11,
    style: {
      fill: "url(#linear-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.74,
    y: 128.25,
    width: 807.48,
    height: 45.95,
    rx: 6.11,
    style: {
      fill: "url(#linear-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.74,
    y: 246.4,
    width: 857.37,
    height: 45.95,
    rx: 6.11,
    style: {
      fill: "url(#linear-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.74,
    y: 246.4,
    width: 713.89,
    height: 45.95,
    rx: 6.11,
    style: {
      fill: "url(#linear-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.74,
    y: 364.54,
    width: 857.37,
    height: 45.95,
    rx: 6.11,
    style: {
      fill: "url(#linear-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.74,
    y: 364.54,
    width: 580.19,
    height: 45.95,
    rx: 6.11,
    style: {
      fill: "url(#linear-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1255.55,
    y: 136.17,
    width: 62.3,
    height: 30.11,
    rx: 4.01,
    style: {
      fill: "url(#linear-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1165.76,
    y: 254.31,
    width: 62.3,
    height: 30.11,
    rx: 4.01,
    style: {
      fill: "url(#linear-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.19,
    y: 372.46,
    width: 62.3,
    height: 30.11,
    rx: 4.01,
    style: {
      fill: "url(#linear-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2086.93 1712.46 216.3-476a15 15 0 0 1 19.9-7.46l357.4 162.4a15 15 0 0 1 7.46 19.9l-216.3 476a15 15 0 0 1-19.9 7.47l-357.39-162.4a15 15 0 0 1-7.47-19.91Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2446.41 1869.09-329.14-149.56a9.4 9.4 0 0 1-4.67-12.45l203.46-447.77a9.41 9.41 0 0 1 12.45-4.68l329.14 149.56a9.42 9.42 0 0 1 4.68 12.46l-203.47 447.77a9.4 9.4 0 0 1-12.45 4.67Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-42)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M2481.53 1437.51 2317.62 1363a2.46 2.46 0 0 1-1.22-3.25l5.62-12.36a2.46 2.46 0 0 1 3.25-1.22l163.91 74.48a2.47 2.47 0 0 1 1.22 3.26l-5.61 12.35a2.47 2.47 0 0 1-3.26 1.25Z",
    transform: "translate(-310.65 -258.9)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2287.91,
    y: 1445.06,
    width: 293.87,
    height: 18.49,
    rx: 2.46,
    transform: "rotate(24.44 2876.963 607.386)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m2544.42 1562.4-263.07-119.53a2.47 2.47 0 0 1-1.22-3.26l5.61-12.36a2.47 2.47 0 0 1 3.26-1.25l263.07 119.54a2.47 2.47 0 0 1 1.22 3.26l-5.62 12.35a2.46 2.46 0 0 1-3.25 1.25ZM2526.28 1602.32l-263.07-119.54a2.47 2.47 0 0 1-1.22-3.26l5.61-12.35a2.47 2.47 0 0 1 3.26-1.22l263.07 119.54a2.46 2.46 0 0 1 1.22 3.25l-5.61 12.36a2.47 2.47 0 0 1-3.26 1.22ZM2399.15 1618.81l-163.91-74.48a2.46 2.46 0 0 1-1.22-3.25l5.61-12.36a2.47 2.47 0 0 1 3.26-1.22l163.91 74.5a2.47 2.47 0 0 1 1.22 3.26l-5.61 12.35a2.47 2.47 0 0 1-3.26 1.2ZM2480.17 1703.79l-263.06-119.54a2.46 2.46 0 0 1-1.23-3.26l5.62-12.35a2.46 2.46 0 0 1 3.25-1.22L2487.82 1687a2.46 2.46 0 0 1 1.22 3.25l-5.61 12.36a2.47 2.47 0 0 1-3.26 1.18ZM2462 1743.7l-263-119.53a2.47 2.47 0 0 1-1.22-3.26l5.61-12.35a2.46 2.46 0 0 1 3.26-1.23l263.06 119.54a2.47 2.47 0 0 1 1.23 3.26l-5.62 12.35a2.46 2.46 0 0 1-3.32 1.22ZM2443.9 1783.62l-263.07-119.54a2.46 2.46 0 0 1-1.22-3.25l5.61-12.36a2.47 2.47 0 0 1 3.26-1.22l263.07 119.54a2.46 2.46 0 0 1 1.22 3.25l-5.61 12.36a2.47 2.47 0 0 1-3.26 1.22Z",
    transform: "translate(-310.65 -258.9)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m2564.72 1317.81-29-13.18a29.81 29.81 0 0 0-52-23.63l-29-13.18a12.71 12.71 0 0 0-16.82 6.32l-9.87 21.71a12.72 12.72 0 0 0 6.31 16.83l110 50a12.7 12.7 0 0 0 16.82-6.31l9.87-21.72a12.71 12.71 0 0 0-6.31-16.84Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-43)"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-75",
    cx: 2507.82,
    cy: 1296.75,
    r: 13.55,
    transform: "rotate(-47.34 2057.35 1521.652)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 391.5,
    cy: 1406.95,
    rx: 385.2,
    ry: 187.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 391.5,
    cy: 1406.95,
    rx: 378.89,
    ry: 184.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 391.5,
    cy: 1406.95,
    rx: 372.59,
    ry: 181.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 391.5,
    cy: 1406.95,
    rx: 366.28,
    ry: 178.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 391.5,
    cy: 1406.95,
    rx: 359.98,
    ry: 175.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 391.5,
    cy: 1406.95,
    rx: 353.67,
    ry: 172.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 391.5,
    cy: 1406.95,
    rx: 347.37,
    ry: 169.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 391.5,
    cy: 1406.95,
    rx: 341.06,
    ry: 166.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 391.5,
    cy: 1406.95,
    rx: 334.76,
    ry: 163.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 391.51,
    cy: 1406.95,
    rx: 328.45,
    ry: 160.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 391.5,
    cy: 1406.95,
    rx: 322.15,
    ry: 157.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 391.5,
    cy: 1406.95,
    rx: 315.84,
    ry: 153.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 391.5,
    cy: 1406.95,
    rx: 309.54,
    ry: 150.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 391.5,
    cy: 1406.95,
    rx: 303.23,
    ry: 147.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 391.5,
    cy: 1406.95,
    rx: 296.93,
    ry: 144.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 391.5,
    cy: 1406.95,
    rx: 290.62,
    ry: 141.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 391.5,
    cy: 1406.95,
    rx: 284.31,
    ry: 138.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 391.5,
    cy: 1406.95,
    rx: 278.01,
    ry: 135.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 391.5,
    cy: 1406.95,
    rx: 271.7,
    ry: 132.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 391.51,
    cy: 1406.95,
    rx: 265.4,
    ry: 129.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 391.5,
    cy: 1406.95,
    rx: 259.09,
    ry: 126.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 391.5,
    cy: 1406.95,
    rx: 252.79,
    ry: 123.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 391.5,
    cy: 1406.95,
    rx: 246.48,
    ry: 120.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 391.5,
    cy: 1406.95,
    rx: 240.18,
    ry: 117.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 391.5,
    cy: 1406.95,
    rx: 233.87,
    ry: 114.01
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 391.5,
    cy: 1406.95,
    rx: 227.57,
    ry: 110.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 391.5,
    cy: 1406.95,
    rx: 221.26,
    ry: 107.86
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 501.86,
    cy: 1015.13,
    rx: 385.2,
    ry: 187.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 501.86,
    cy: 1015.13,
    rx: 378.89,
    ry: 184.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 501.86,
    cy: 1015.13,
    rx: 372.59,
    ry: 181.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 501.86,
    cy: 1015.13,
    rx: 366.28,
    ry: 178.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 501.86,
    cy: 1015.13,
    rx: 359.98,
    ry: 175.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 501.86,
    cy: 1015.13,
    rx: 353.67,
    ry: 172.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 501.86,
    cy: 1015.13,
    rx: 347.37,
    ry: 169.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 501.86,
    cy: 1015.13,
    rx: 341.06,
    ry: 166.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 501.86,
    cy: 1015.13,
    rx: 334.76,
    ry: 163.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 501.86,
    cy: 1015.13,
    rx: 328.45,
    ry: 160.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 501.86,
    cy: 1015.13,
    rx: 322.15,
    ry: 157.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 501.86,
    cy: 1015.13,
    rx: 315.84,
    ry: 153.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 501.86,
    cy: 1015.13,
    rx: 309.54,
    ry: 150.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 501.86,
    cy: 1015.13,
    rx: 303.23,
    ry: 147.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 501.86,
    cy: 1015.13,
    rx: 296.93,
    ry: 144.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 501.86,
    cy: 1015.13,
    rx: 290.62,
    ry: 141.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 501.86,
    cy: 1015.13,
    rx: 284.31,
    ry: 138.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 501.86,
    cy: 1015.13,
    rx: 278.01,
    ry: 135.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 501.86,
    cy: 1015.13,
    rx: 271.7,
    ry: 132.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 501.86,
    cy: 1015.13,
    rx: 265.4,
    ry: 129.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 501.86,
    cy: 1015.13,
    rx: 259.09,
    ry: 126.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 501.86,
    cy: 1015.13,
    rx: 252.79,
    ry: 123.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 501.86,
    cy: 1015.13,
    rx: 246.48,
    ry: 120.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 501.86,
    cy: 1015.13,
    rx: 240.18,
    ry: 117.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 501.86,
    cy: 1015.13,
    rx: 233.87,
    ry: 114.01
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 501.86,
    cy: 1015.13,
    rx: 227.57,
    ry: 110.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 501.86,
    cy: 1015.13,
    rx: 221.26,
    ry: 107.86
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m1080 1263.3 180.91-272.83a21 21 0 0 0-6.14-29.26l-360.85-232a25 25 0 0 0-34.32 7.2l-179.12 270.05 377.4 256.84Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1057.88 1263.3 180.92-272.83a21 21 0 0 0-6.15-29.26L871.8 729.2a25 25 0 0 0-34.31 7.2l-179.08 270.06Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-45)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M675.31 1001.53 849.38 739a7.3 7.3 0 0 1 6.1-3.27 7.13 7.13 0 0 1 3.92 1.16L1231 975.82a3.13 3.13 0 0 1 1.41 2 3.21 3.21 0 0 1-.47 2.44l-176.25 265.78Z",
    transform: "translate(-310.65 -258.9)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m808.48 1318.77 236.84-34.26 12.56-21.21-407.05-234.1-219 10.5c-8.09 1.17-15.18 33.6-8.33 38l366 236.9a27.53 27.53 0 0 0 18.98 4.17Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m816.06 1296 241.82-32.74-399.47-256.8-223.75 32.37a8.84 8.84 0 0 0-3.54 16.17l366 236.9a27.58 27.58 0 0 0 18.94 4.1Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.3 1233.61 666.08 1034a23.3 23.3 0 0 0-16.29-3.38l-91.9 14.87a7.14 7.14 0 0 0-2.71 13.06l305.19 195.75a26.21 26.21 0 0 0 17 4l96.66-10.87a7.52 7.52 0 0 0 3.27-13.82Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m683.54 1053.41-12-7a3.83 3.83 0 0 0-2.53-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.44 4.44 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m702.65 1065.83-12-7a3.83 3.83 0 0 0-2.53-.5l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.41 4.41 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m721.76 1078.25-12-7a3.83 3.83 0 0 0-2.53-.5l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.41 4.41 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m740.87 1090.67-12-7a3.83 3.83 0 0 0-2.53-.5l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.42 4.42 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-52)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m760 1103.09-12-7a3.81 3.81 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.42 4.42 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .31-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m779.1 1115.51-12-7a3.87 3.87 0 0 0-2.52-.49l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.42 4.42 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .31-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m798.21 1127.93-12-7a3.88 3.88 0 0 0-2.53-.49l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.44 4.44 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m817.32 1140.35-12-7a3.88 3.88 0 0 0-2.53-.49l-13.94 2.14a1 1 0 0 0-.28 1.91l11.07 6.43a4.44 4.44 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .35-1.98Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m836.43 1152.77-12-7a3.88 3.88 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.41 4.41 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855.54 1165.19-12-7a3.88 3.88 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.41 4.41 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m874.65 1177.61-12-7a3.88 3.88 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.42 4.42 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m657 1057.76-12-7a3.89 3.89 0 0 0-2.53-.5l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.34 4.34 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m676.11 1070.18-12-7a3.89 3.89 0 0 0-2.53-.5l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m695.22 1082.6-12-7a3.87 3.87 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .31-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m714.34 1095-12-7a3.87 3.87 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58L714 1097a1.06 1.06 0 0 0 .34-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m733.45 1107.44-12-7a3.89 3.89 0 0 0-2.53-.5l-13.92 2.18a1 1 0 0 0-.28 1.91l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .33-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m752.56 1119.86-12-7a3.83 3.83 0 0 0-2.53-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m771.67 1132.28-12-7a3.83 3.83 0 0 0-2.53-.5L743.2 1127a1 1 0 0 0-.28 1.91l11.08 6.39a4.32 4.32 0 0 0 2.64.58l14.68-1.59a1.06 1.06 0 0 0 .35-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m790.78 1144.7-12-7a3.83 3.83 0 0 0-2.53-.5l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.34 4.34 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m809.89 1157.12-12-7a3.83 3.83 0 0 0-2.53-.5l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m829 1169.54-12-7a3.81 3.81 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m848.12 1182-12-7a3.81 3.81 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .31-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-70)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630.46 1062.11-12-7a3.81 3.81 0 0 0-2.52-.49L602 1056.8a1 1 0 0 0-.28 1.9l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .35-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m649.58 1074.53-12-7a3.81 3.81 0 0 0-2.52-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .31-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.69 1087-12-7a3.85 3.85 0 0 0-2.53-.49l-13.91 2.17a1 1 0 0 0-.28 1.9L651 1090a4.35 4.35 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .36-1.99Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m687.8 1099.37-12-7a3.89 3.89 0 0 0-2.53-.5l-13.91 2.18a1 1 0 0 0-.28 1.9l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m706.91 1111.79-12-7a3.89 3.89 0 0 0-2.53-.5l-13.91 2.18a1 1 0 0 0-.28 1.9l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m726 1124.21-12-7a3.89 3.89 0 0 0-2.53-.5l-13.9 2.18a1 1 0 0 0-.28 1.9l11.07 6.43a4.34 4.34 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m745.13 1136.63-12-7a3.89 3.89 0 0 0-2.53-.5l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.34 4.34 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m764.24 1149.05-12-7a3.87 3.87 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m783.36 1161.47-12-7a3.87 3.87 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .31-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m802.47 1173.89-12-7a3.91 3.91 0 0 0-2.53-.5l-13.94 2.18a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .35-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-80)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m821.58 1186.31-12-7a3.89 3.89 0 0 0-2.53-.5l-13.94 2.19a1 1 0 0 0-.28 1.91l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .35-2.02Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-81)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m603.93 1066.46-12-7a3.81 3.81 0 0 0-2.52-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.28 4.28 0 0 0 2.65.58l14.68-1.58a1.07 1.07 0 0 0 .31-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623 1078.88-12-7a3.82 3.82 0 0 0-2.53-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.3 4.3 0 0 0 2.65.58l14.68-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.15 1091.3-12-7a3.82 3.82 0 0 0-2.53-.49l-13.94 2.19a1 1 0 0 0-.28 1.9l11.07 6.43a4.3 4.3 0 0 0 2.65.58l14.68-1.58a1.07 1.07 0 0 0 .35-2.03Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m661.26 1103.72-12-7a3.82 3.82 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.25 4.25 0 0 0 2.64.58l14.68-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680.37 1116.14-12-7a3.82 3.82 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.34 4.34 0 0 0 2.65.58l14.67-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-86)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m699.48 1128.56-12-7a3.82 3.82 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.67-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m718.59 1141-12-7a3.81 3.81 0 0 0-2.52-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.58a1.06 1.06 0 0 0 .31-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m737.71 1153.4-12-7a3.81 3.81 0 0 0-2.52-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.58a1.07 1.07 0 0 0 .31-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m756.82 1165.82-12-7a3.82 3.82 0 0 0-2.53-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m775.93 1178.24-12-7a3.82 3.82 0 0 0-2.53-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m795 1190.66-12-7a3.82 3.82 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.32 4.32 0 0 0 2.64.58l14.68-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m895.35 1190.66-12-7a3.82 3.82 0 0 0-2.53-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m868.81 1195-12-7a3.82 3.82 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.27 4.27 0 0 0 2.65.58l14.67-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m842.27 1199.37-12-7a3.88 3.88 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.42a4.28 4.28 0 0 0 2.65.58l14.67-1.58a1.06 1.06 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m815.74 1203.72-12-7a3.81 3.81 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.42 4.42 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .31-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m916 1203.72-12-7a3.81 3.81 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.42 4.42 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m889.51 1208.07-12-7a3.87 3.87 0 0 0-2.52-.5l-13.99 2.18a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .39-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m863 1212.42-12-7a3.82 3.82 0 0 0-2.53-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .32-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m836.43 1216.77-12-7a3.82 3.82 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.27 4.27 0 0 0 2.65.58l14.67-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-100)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m936.74 1216.77-12-7a3.82 3.82 0 0 0-2.53-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.3 4.3 0 0 0 2.65.58l14.68-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-101)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m910.2 1221.12-12-7a3.88 3.88 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.91l11.07 6.42a4.27 4.27 0 0 0 2.65.58l14.67-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-102)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m883.66 1225.48-12-7a3.88 3.88 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.91l11.05 6.43a4.42 4.42 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .34-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-103)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m857.13 1229.83-12-7a3.81 3.81 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .31-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-104)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m957.43 1229.83-12-7a3.81 3.81 0 0 0-2.52-.5l-13.91 2.18a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.67-1.59a1.06 1.06 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-105)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m930.9 1234.18-12-7a3.87 3.87 0 0 0-2.52-.5l-13.91 2.17a1 1 0 0 0-.28 1.91l11.07 6.43a4.35 4.35 0 0 0 2.65.58l14.68-1.59a1.06 1.06 0 0 0 .31-2Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-106)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m904.36 1238.53-12-7a3.82 3.82 0 0 0-2.53-.49l-13.91 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.37 4.37 0 0 0 2.65.58l14.68-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-107)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m877.82 1242.88-12-7a3.82 3.82 0 0 0-2.53-.49l-13.9 2.17a1 1 0 0 0-.28 1.9l11.07 6.43a4.27 4.27 0 0 0 2.65.58l14.67-1.58a1.07 1.07 0 0 0 .32-2.01Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-108)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 982.05,
    y: 941.07,
    width: 26.29,
    height: 43.66,
    rx: 1.66,
    transform: "rotate(32.91 1278.116 307.506)",
    style: {
      fill: "url(#linear-gradient-109)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.59,
    y: 942.5,
    width: 26.29,
    height: 66.89,
    rx: 1.66,
    transform: "rotate(32.91 1319.665 320.56)",
    style: {
      fill: "url(#linear-gradient-110)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1028.22,
    y: 966.66,
    width: 112.03,
    height: 26.29,
    rx: 1.66,
    transform: "rotate(-57.09 690.969 1135.905)",
    style: {
      fill: "url(#linear-gradient-111)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1101.48,
    y: 962.99,
    width: 26.29,
    height: 94.2,
    rx: 1.66,
    transform: "rotate(32.91 1397.55 354.686)",
    style: {
      fill: "url(#linear-gradient-112)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m955.26 912.9-99.49-68.24a.8.8 0 0 1-.21-1.11l3.88-5.66a.81.81 0 0 1 1.11-.21l99.5 68.25a.8.8 0 0 1 .2 1.11l-3.88 5.66a.8.8 0 0 1-1.11.2ZM943.18 930.53l-99.49-68.24a.79.79 0 0 1-.21-1.11l3.88-5.66a.79.79 0 0 1 1.11-.21L948 923.55a.79.79 0 0 1 .21 1.11l-3.88 5.66a.8.8 0 0 1-1.15.21Z",
    transform: "translate(-310.65 -258.9)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 825.95,
    y: 895.57,
    width: 84.27,
    height: 8.46,
    rx: 0.8,
    transform: "rotate(34.45 1130.238 269.193)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m1027.27 1122.18-99.5-68.24a.8.8 0 0 1-.2-1.11l3.88-5.67a.8.8 0 0 1 1.11-.2l99.49 68.24a.79.79 0 0 1 .21 1.11l-3.88 5.66a.8.8 0 0 1-1.11.21Z",
    transform: "translate(-310.65 -258.9)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 906.71,
    y: 1097.96,
    width: 122.24,
    height: 8.46,
    rx: 0.8,
    transform: "rotate(34.45 1229.978 471.562)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 897.96,
    y: 1104.85,
    width: 84.27,
    height: 8.46,
    rx: 0.8,
    transform: "rotate(34.45 1202.238 478.448)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M828.35 947.72a46.7 46.7 0 0 1 42.18 42.19l9 .58 4.31-.58a59.91 59.91 0 0 0-55.46-55.47L824 935Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-113)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.54 989.91a46.7 46.7 0 0 1 42.19-42.19v-13.28a59.92 59.92 0 0 0-55.47 55.47l9 .58Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-114)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.53 998.52a46.7 46.7 0 0 1-42.18 42.19V1054a59.9 59.9 0 0 0 55.46-55.47Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.73 1040.71a46.7 46.7 0 0 1-42.19-42.19h-13.28a59.91 59.91 0 0 0 55.47 55.48Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-116)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824 948.31a46.69 46.69 0 0 1 42.18 42.18h13.32A59.9 59.9 0 0 0 824 935Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-117)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.23 990.49a46.7 46.7 0 0 1 42.19-42.18V935A59.92 59.92 0 0 0 760 990.49Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-118)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.22 999.11A46.69 46.69 0 0 1 824 1041.3v13.28a59.91 59.91 0 0 0 55.46-55.47Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-119)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.42 1041.3a46.7 46.7 0 0 1-42.19-42.19H760a59.92 59.92 0 0 0 55.47 55.47Z",
    transform: "translate(-310.65 -258.9)",
    style: {
      fill: "url(#linear-gradient-120)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#325bad"
    },
    d: "m568.85 740.21 4.31-.59h-13.28l-4.31.59h13.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9fa5"
    },
    d: "m509.07 781.81-4.3.58v13.28l4.3-.58v-13.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-121)"
    },
    d: "m509.07 675.54-4.3.58v13.28l4.3-.58v-13.28z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimization);
export default __webpack_public_path__ + "static/media/optimization.7bef57a5911fd350c32614ab2ee012e9.svg";
export { ForwardRef as ReactComponent };